export function removeHtmlTags (html) {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
}



// WEBPACK FOOTER //
// ./utilities/removeHtmlTags.js